import { createContext, useContext } from 'react';

import { PaymentMethod as DepositMethod } from 'components/wallet/BankEthAccounting/AddFundsToFiatWallet/types';

interface DepositContextType {
  defaultDepositMethod?: DepositMethod;
  setDefaultDepositMethod: (mounted: DepositMethod) => void;
}

export const DepositContext = createContext<DepositContextType | null>(null);

export const useDepositContext = () => useContext(DepositContext)!;
